// Funcionalidad de hover para imagen en sección específica
function initializeSectionImageHover() {
  console.log('initializeSectionImageHover')
  const section = document.querySelector('#shopify-section-template--26166835446043__media_with_text_NhVPtc');
  if (!section) return;

  const imgContainer = section.querySelector('.media-with-text__media');
  const originalImg = imgContainer?.querySelector('img');

  if (!originalImg) return;

  // Crear imagen hover duplicando atributos del original
  const hoverImg = originalImg.cloneNode(true);

  // Cambiar SRC a hover
  const hoverBaseURL = "//funcionalweb.com/cdn/shop/files/Modulo_04_hover.png?v=1763745102";
  hoverImg.src = hoverBaseURL + "&width=1700";

  // --- Generar SRCSET para hover reemplazando base → hover ---
  const baseSrcset = originalImg.getAttribute("srcset");
  if (baseSrcset) {
    const hoverSrcset = baseSrcset.replace(/Modulo_04_base/g, "Modulo_04_hover");
    hoverImg.setAttribute("srcset", hoverSrcset);
  }

  // Estilos de overlay
  hoverImg.style.position = "absolute";
  hoverImg.style.inset = "0";
  hoverImg.style.opacity = "0";
  hoverImg.style.transition = "opacity .3s ease";
  hoverImg.style.pointerEvents = "none";

  // Asegurar el contenedor
  imgContainer.style.position = "relative";

  // Insertar la imagen hover arriba
  imgContainer.appendChild(hoverImg);

  // Eventos de hover
  imgContainer.addEventListener("mouseenter", () => {
    hoverImg.style.opacity = "1";
  });

  imgContainer.addEventListener("mouseleave", () => {
    hoverImg.style.opacity = "0";
  });
}

// Inicializar cuando el DOM esté listo
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeSectionImageHover);
} else {
  initializeSectionImageHover();
}
